import React from 'react';
import SkillGraphCard from '../Components/SkillGraphCard';
import CliftonGraphCard from '../Components/CliftonGraphCard';
import AchievementsCard from '../Components/AchievementsCard';
import ApplyingRolePreview from '../Components/ApplyingRolePreview';
import ApplyingRoleEditPanel from '../Components/ApplyingRoleEditPanel';
import Pagination from '../Components/Generic/Pagination';
import BrandedJobApplicationBanner from '../Components/JobApplicationBanner';
import { useParams } from 'react-router';

export default function JobApplications() {
    const {id} = useParams();
    
    React.useEffect(() => {
        if (id) {
            const applyingJob = document.getElementById(`${id}-applying-job`);
            if (applyingJob) applyingJob.scrollIntoView({ behavior: "smooth" });
        }
    }, [id]);
    return (
        <>
            <div>
                {id ? (
                    <ApplyingRoleEditPanel id={id} className="w-100 shadow"/>
                ) : (
                    <ApplyingRolePreview limit={12} Pagination={Pagination} className="w-100 shadow"/>
                )}
            </div>
            <BrandedJobApplicationBanner className="w-100 shadow" />
            <div className="d-flex flex-row flex-wrap flex-lg-nowrap align-items-stretch gap-4">
                <div className="d-flex flex-column gap-4 flex-grow-1">
                    <SkillGraphCard className="flex-grow-1 w-100 shadow"/>
                    <CliftonGraphCard className="flex-grow-1 w-100 shadow"/>
                </div>
                <div className="flex-grow-1">
                    <AchievementsCard className="flex-grow-1 w-100 h-100 shadow"/>
                </div>
            </div>
        </>
    );
}